import { type AcquireBookZenbujiko } from "@/types/acquirebook";

/**
 * 全部事項オプション（PictureRequestDetail.OptionType コード）の日本語表示ラベル。
 * 取得履歴の全部事項セル Tooltip で「取得時にどのオプションを選んだか」を表示するために使う。
 * 「現在事項」は単独コードにならず、取得時に目録コードを _GENZAI バリアントへ変換する仕様のため、
 * _GENZAI コードを「（現在事項）」付きラベルで表す。
 */
const ZENBUJIKO_OPTION_LABELS: Record<AcquireBookZenbujiko, string> = {
  KYODOTANPOMOKUROKU: "共同担保目録",
  KYODOTANPOMOKUROKU_GENZAI: "共同担保目録（現在事項）",
  SHINTAKUMOKUROKU: "信託目録",
  SHINTAKUMOKUROKU_GENZAI: "信託目録（現在事項）",
  HEISATOUKIBO: "閉鎖登記簿",
};

/**
 * 全部事項オプションコードを日本語表示ラベルへ変換する。
 * 未知コード（FE 型が追従する前に BE が新オプションを返した等）はコードをそのまま返す。
 * @param option OptionType コード（BE レスポンス由来）
 * @example
 * getZenbujikoOptionLabel("KYODOTANPOMOKUROKU") // "共同担保目録"
 */
export const getZenbujikoOptionLabel = (option: AcquireBookZenbujiko): string =>
  ZENBUJIKO_OPTION_LABELS[option] ?? option;
